"use client";

import Link from "next/link";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, UI } from "@/lib/constants";
import Map from "@/components/ui/map";
import GoogleMapsProvider from "@/components/providers/googleMapsProvider";
import { MapMarker } from "@/types";

export default function ContactInfo() {
  const coordinates = UI.coordinates.split(",");

  const markers: MapMarker[] = [
    {
      id: "1",
      position: {
        lat: parseFloat(coordinates[0]),
        lng: parseFloat(coordinates[1]),
      },
      title: COMPANY.name,
    },
  ];

  return (
    <div>
      <h2 className='text-2xl font-semibold mb-4'>Company Information</h2>
      <div className='space-y-4 mb-6'>
        <div className='flex items-center'>
          <Phone className='mr-2' />
          <Link href={`tel:${COMPANY.phone}`}>
            {COMPANY.phone.replace(/(\+61)(\d)(\d{4})(\d{4})/, "$1 $2 $3 $4")}
          </Link>
        </div>
        <div className='flex items-center'>
          <Mail className='mr-2' />
          <Link href={`mailto:${COMPANY.email}`}>{COMPANY.email}</Link>
        </div>
        <div className='flex items-center'>
          <MapPin className='mr-2' />
          <Link
            href={`https://maps.google.com/?q=${COMPANY.address.street}, ${COMPANY.address.state} ${COMPANY.address.postcode}`}
          >
            {COMPANY.address.street}, {COMPANY.address.city},{" "}
            {COMPANY.address.state}, {COMPANY.address.country},{" "}
            {COMPANY.address.postcode}
          </Link>
        </div>
      </div>
      <div className='h-64 md:h-96 rounded-lg overflow-hidden'>
        <GoogleMapsProvider>
          <Map markers={markers} selectedAddresses={[]} />
        </GoogleMapsProvider>
      </div>
    </div>
  );
}
